import { Alert } from "antd"

type Props = {
  reason: string | null
}

const PaymentFeesBlockedAlert = ({ reason }: Props) => {
  if (reason === null) {
    return null
  }
  return <Alert
    type="warning"
    showIcon
    message="You can't pass on payment fees yet."
    description={<>{reason} <a href="mailto:support@synkedup.com">Contact support</a> if you have questions.</>}
  />
}

export default PaymentFeesBlockedAlert
